import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

const MAX_COMMENT_LENGTH = 150;

export function commentValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = typeof control.value === 'string' ? control.value : '';

    if (!value) {
      return null;
    }

    if (value !== value.trim()) {
      return { incorrectComment: true };
    }

    if (value.length > MAX_COMMENT_LENGTH) {
      return { incorrectComment: true };
    }

    const htmlTagPattern = REGEX.htmlTagPattern;
    if (htmlTagPattern.test(value)) {
      return { incorrectComment: true };
    }

    const allowedPattern = REGEX.allowComment;
    if (!allowedPattern.test(value)) {
      return { incorrectComment: true };
    }

    return null;
  };
}
